import { render, staticRenderFns } from "./RsaConfigurazioneLaboratoriEditPage.vue?vue&type=template&id=04141f8c"
import script from "./RsaConfigurazioneLaboratoriEditPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneLaboratoriEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports